import React from 'react';
import { Icon } from 'ui';
import Item from 'components/_shared/dropdown_menu/dropdown_menu_item';

const Option = ({ onClick, value, icon, label }) => (
  <Item
    onClick={e => {
      e.stopPropagation();
      onClick(value);
    }}
  >
    <Icon name={icon} />
    {label}
  </Item>
);

export default Option;
